/* ==========================================================================
   RPBA cart drawer - JS body scroll lock (mobile). 24 Aug 2026.

   WHY
   On iPhone the drawer scrolled DOWN but would not scroll back UP - it lost the
   gesture to the document behind the sheet. The theme has no body scroll lock
   anywhere (checked cart-addons.liquid, minicart.liquid, theme.liquid).

   The CSS-only attempt (rpba-cart-drawer-scrolllock.css: overscroll-behavior +
   html/body overflow:hidden via :has()) did not cure it. iOS Safari does not
   reliably stop scrolling on overflow:hidden alone - the documented fix is
   position:fixed on body with the scroll offset held in `top`, restored on close.

   WHAT IT DOES
   Watches the theme's own `.active` class on .minicart via MutationObserver.
     open  -> record pageYOffset, body{position:fixed; top:-Y; left:0; right:0}
     close -> clear those, window.scrollTo(0, Y)
   Coarse pointers only. No markup changes, no theme JS touched.

   DEBUG
   Add ?cartdebug=1 to any store URL for a live on-screen readout of the drawer
   state, both scrollers, window scroll and the last touch target. Use it to
   diagnose rather than guess. It renders only with that parameter present.
   ========================================================================== */
(function () {
  'use strict';

  var scrollY = 0;
  var locked = false;

  function isCoarse() {
    return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  }

  function lock() {
    if (locked || !isCoarse()) return;
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-scrollY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.classList.add('rpba-cart-locked');
    locked = true;
  }

  function unlock() {
    if (!locked) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.classList.remove('rpba-cart-locked');
    locked = false;
    window.scrollTo(0, scrollY);
  }

  function watch(mc) {
    new MutationObserver(function () {
      if (mc.classList.contains('active')) lock(); else unlock();
    }).observe(mc, { attributes: true, attributeFilter: ['class'] });
    if (mc.classList.contains('active')) lock();
  }

  function init() {
    var mc = document.querySelector('.js-minicart.minicart');
    if (!mc) return false;
    watch(mc);
    return true;
  }

  function boot() {
    if (init()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (init() || ++tries > 40) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ---------- ?cartdebug=1 on-screen readout ---------- */
  if (/[?&]cartdebug=1/.test(location.search)) {
    var panel = document.createElement('div');
    panel.style.cssText = 'position:fixed;left:0;top:0;z-index:2147483647;' +
      'background:rgba(0,0,0,.85);color:#5f5;font:11px/1.4 ui-monospace,Menlo,monospace;' +
      'padding:6px 8px;max-width:100%;pointer-events:none;white-space:pre';
    var lastTouch = '-';

    document.addEventListener('touchstart', function (e) {
      var t = e.target;
      var c = (t.className || '').toString().trim().split(/\s+/).slice(0, 2).join('.');
      lastTouch = c || t.tagName || '?';
    }, { passive: true, capture: true });

    var attach = function () {
      document.body.appendChild(panel);
      setInterval(function () {
        var mc = document.querySelector('.minicart');
        var sc = mc && mc.querySelector('.mini-content');
        var pr = mc && mc.querySelector('.prod');
        var range = function (el) {
          return el ? (el.scrollTop + ' / ' + (el.scrollHeight - el.clientHeight)) : '-';
        };
        panel.textContent =
          'open:' + !!(mc && mc.classList.contains('active')) +
            '  coarse:' + isCoarse() + '  locked:' + locked + '\n' +
          'mini-content: ' + range(sc) + '\n' +
          'prod:         ' + range(pr) + '\n' +
          'window.scrollY: ' + Math.round(window.pageYOffset) +
            '  innerH: ' + window.innerHeight + '\n' +
          'last touch: ' + lastTouch;
      }, 200);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    } else {
      attach();
    }
  }
})();
